import React from 'react';
import classNames from 'classnames';
import styles from './LabelledIcon.css';

export function LabelledIconRow({
  children,
  onClick,
  inverted,
  className,
  contactIsLoaded,
  displayName,
  displayHandle,
  test,
}) {
  let Element = onClick ? 'button' : 'div';

  return (
    <Element
      className={classNames(
        styles.row,
        onClick && styles.clickable,
        inverted && styles.inverted,
        className,
      )}
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      data-test={test}
      data-loading={test ? !contactIsLoaded : undefined}
      data-entity-name={test ? displayName : undefined}
      data-entity-handle={test ? displayHandle : undefined}
    >
      {children}
    </Element>
  );
}

export const LabelledIcon = ({ children, className }) => (
  <div className={styles.iconColumn}>
    <div className={classNames(styles.iconRow, className)}>{children}</div>
  </div>
);

export const LabelledIconBody = ({
  children,
  centered,
  twoLineHeight,
  className,
}) => (
  <div className={styles.bodyColumn}>
    <div
      className={classNames(
        styles.bodyRow,
        centered && styles.centered,
        twoLineHeight && styles.twoLineHeight,
        className,
      )}
    >
      {children}
    </div>
  </div>
);

export const LabelledIconLeftColumn = ({
  children,
  regularWeight,
  className,
}) => (
  <div
    className={classNames(
      styles.leftColumn,
      regularWeight && styles.regularWeight,
      className,
    )}
  >
    {children}
  </div>
);

export const LabelledIconRightColumn = ({
  children,
  regularWeight,
  className,
}) => (
  <div
    className={classNames(
      styles.rightColumn,
      regularWeight && styles.regularWeight,
      className,
    )}
  >
    {children}
  </div>
);
